import { Animated } from "react-native";
import { useAppTheme } from "../../../../useAppTheme";
import {
	CONNECTOR_LENGTH,
	CONNECTOR_OVERLAP,
	CONNECTOR_THICKNESS,
	RING_DIAMETER,
} from "./constants";

type Props = {
	/** 0 → 1 for this connector's slice of the draw-in. Timing lives in the parent. */
	progress: Animated.Value;
};

export const ToeicLevelConnector = ({ progress }: Props) => {
	const theme = useAppTheme();

	const width = progress.interpolate({
		inputRange: [0, 1],
		outputRange: [0, CONNECTOR_LENGTH],
	});

	return (
		<Animated.View
			style={{
				width: CONNECTOR_LENGTH,
				height: CONNECTOR_THICKNESS,
				marginHorizontal: -CONNECTOR_OVERLAP,
				// Align with the ring centre rather than the node box, which also
				// contains the label stack below it.
				marginTop: (RING_DIAMETER - CONNECTOR_THICKNESS) / 2,
				alignSelf: "flex-start",
			}}
		>
			<Animated.View
				style={{
					width,
					height: CONNECTOR_THICKNESS,
					backgroundColor: theme.palette.progress.high,
				}}
			/>
		</Animated.View>
	);
};
